<template>
  <div
    :class="['spend-popup', light && 'spend-popup--light']"
    @click.stop
  >
    <div class="spend-popup-header">
      Daily Bdgt: <span class="spend-popup-dollar">${{ weeklySpendData.dailyBudget }}</span>
    </div>
    <div class="spend-popup-header">
      Avg Spend: <span class="spend-popup-avg">{{ avgPercent }}%</span>
    </div>
    <table class="spend-popup-table">
      <tr>
        <th>Day</th>
        <th>Spent</th>
      </tr>
      <tr
        v-for="(day, di) in weeklySpendData.days"
        :key="di"
      >
        <td>{{ dayNames[di] }}</td>
        <td :class="dayClass(day)">
          {{ day.percent }}%<span
            v-if="!day.zero && day.percent > avgPercent"
            class="spend-day--above"
          >&#9650;</span><span
            v-else-if="!day.zero && day.percent < avgPercent"
            class="spend-day--below"
          >&#9660;</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'SpendBudgetPopup',

  props: {
    weeklySpendData: {
      type: Object,
      required: true
    },
    avgPercent: {
      type: Number,
      required: true
    },
    light: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    }
  },

  methods: {
    dayClass(day) {
      if (day.zero) {
        return 'spend-day--zero'
      }

      if (day.percent <= 30) {
        return 'spend-day--low'
      }

      return 'spend-day--high'
    }
  }
}
</script>

<style scoped>
.spend-popup {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1001;
  background: #1f2937;
  border: 1px solid #4b5563;
  border-radius: 6px;
  padding: 8px 10px;
  margin-top: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  pointer-events: auto;
}

.spend-popup-header {
  font-size: 0.7rem;
  color: #d1d5db;
  margin-bottom: 4px;
  white-space: nowrap;
}

.spend-popup-dollar {
  color: #86efac;
  font-size: 0.8rem;
}

.spend-popup-avg {
  color: #f5deb3;
  font-size: 0.8rem;
}

.spend-popup-table {
  font-size: 0.65rem;
  border-collapse: collapse;
  width: 100%;
}

.spend-popup-table th,
.spend-popup-table td {
  padding: 2px 6px;
  text-align: left;
}

.spend-popup-table th {
  color: #9ca3af;
  border-bottom: 1px solid #374151;
}

.spend-popup-table td {
  color: #e5e7eb;
}

.spend-day--zero {
  color: #6b7280;
}

.spend-day--low {
  color: #fca5a5;
}

.spend-day--high {
  color: #86efac;
}

.spend-day--above {
  color: #86efac;
  font-size: 0.5rem;
  margin-left: 2px;
  vertical-align: middle;
}

.spend-day--below {
  color: #fca5a5;
  font-size: 0.5rem;
  margin-left: 2px;
  vertical-align: middle;
}

.spend-popup--light {
  background: #ffffff;
  border: 1px solid #d1d5db;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.spend-popup--light .spend-popup-header {
  color: #374151;
}

.spend-popup--light .spend-popup-dollar {
  color: #059669;
}

.spend-popup--light .spend-popup-avg {
  color: #1e3a5f;
}

.spend-popup--light .spend-popup-table th {
  color: #6b7280;
  border-bottom: 1px solid #e5e7eb;
}

.spend-popup--light .spend-popup-table td {
  color: #1f2937;
}

.spend-popup--light .spend-day--zero {
  color: #9ca3af;
}

.spend-popup--light .spend-day--low {
  color: #dc2626;
}

.spend-popup--light .spend-day--high {
  color: #059669;
}

.spend-popup--light .spend-day--above {
  color: #059669;
}

.spend-popup--light .spend-day--below {
  color: #dc2626;
}
</style>
